import {forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState} from "react";
import Modal from "../components/Modal";
import user from "../assets/user.png";
import * as React from "react";
import Box from '@mui/material/Box';
import LoadingSpinner from "./LoadingSpinner";
import {ActiveCellStyle, ScrollingTextRenderer, StatusCellStyle} from "./renderer/StyleRenderer";
import {clusterById} from "../api/clusterNameApi";
import Grid from "./Grid";
import {
    getDeviceRegistrationData,
    getQrRegistrationData,
    getQrRegistrationDataByCompany,
    getRegisteredDevices, getUserData,
    processDeviceActive, sendRegisterBulkData, sendRegisterDeviceDataByForm
} from "../api/deviceRegistrationApi";
import {QRCodeCanvas} from "qrcode.react";
import QRCode from "./QRCode";
import Dropdown from "./input/Dropdown";
import Button from "./input/Button";
import {Cpu} from "react-feather";
import {getDropdownData} from "../api/keyvalue";
import {useSelector} from "react-redux";
import {approvalProcessValidation} from "./validations/ApprovalProcessCreation";
import {errorActions} from "../store/error-slice";
import {toast} from "react-toastify";
import {processApproval} from "../api/finance/ApprovalProcessApi";
import useUserCompany from "../hooks/useUserCompany";
import {formatFromJsonDate} from "../dateConfig";
import DeviceRegisterForm from "./device-register/DeviceRegisterForm";
import {contactValidation} from "./validations/stakeholderCreation";
import {
    deviceBulkRegisterValidation,
    deviceRegisterFormValidation,
    mobileNumberValidation
} from "./validations/DeviceRegisterCreation";
import {FORMS, MODULES} from "../const";
import DeviceBulkRegister from "./device-register/DeviceBulkRegister";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
};

const HEADER_FORM = FORMS?.DEVICE_MANAGER?.REGISTER_DEVICE?.form;
const RegisterDevices = forwardRef(({openModel,setCloseModel}, ref)=> {

        const auth = useSelector((state) => state.user.permissions[MODULES.Master]);
    const deviceManagerPermissions = HEADER_FORM ? auth?.[HEADER_FORM] : {};
        const devPermissions = deviceManagerPermissions?.FORM?.CREATE;

        const [isLoading, setIsLoading] = useState(false);
        const [isSearchLoading, setIsSearchLoading] = useState(false);
        const [devRegData, setDevRegData] = useState({});
        const [registeredDev, setRegisteredDev] = useState([]);
        const [active , setActive] = useState(1);
        const user = useSelector((state) => state.user);
        const userCompany = useUserCompany();
        const [isSubmitLoading, setIsSubmitLoading] = useState(false);
        const [deviceRegisterType, setDeviceRegisterType] = useState(null);
        const [buttonClicked, setButtonClicked] = useState(false);

        // grid popup
        const [showCloseButton, setShowCloseButton] = useState(false);
        const modalRef = useRef();

        // device popup
        const [isDeviceRegisterPopup, setIsDeviceRegisterPopup] = useState(false);

        // check box
        const [selectedRows, setSelectedRows] = useState([]);
        const gridRef = useRef();

        // dropdown
        const [activeOptions, setActiveOptions] = useState([]);
        const [registerTypeOptions, setRegisterTypeOptions] = useState([]);

        //errors

        // const [currentErrors, setCurrentErrors] = useState({});
        // useEffect(() => {
        //     setCurrentErrors(errorState);
        // }, [errorState]);

        const [currentContactErrors, setCurrentContactErrors] = useState({})

        //ref
        const formRef = useRef();
        const bulkRef = useRef();

        const handleSelectionChanged = useCallback(() => {
            const selectedData = gridRef.current.getSelectedData();
            setActive(1);
            setSelectedRows(selectedData);
        }, []);

        const [company, setCompany] = useState(
            userCompany ? userCompany.comId : null
        );
        useEffect(() => {
            setCompany(userCompany ? userCompany.comId : null);
        }, [userCompany]);

        const handleGridLoad = async () => {
            setIsLoading(true)
            setActive(1);
            const response = await getRegisteredDevices(company, user.username);
            const mappedRes = response?.map((item) => ({
                ...item,
                createdDate: item.createdDate
                    ? formatFromJsonDate(item.createdDate)
                    : "",
                lastModifiedDate: item.lastModifiedDate
                    ? formatFromJsonDate(item.lastModifiedDate)
                    : "",
                lastLoggedDate: item.lastLoggedDate
                    ? formatFromJsonDate(item.lastLoggedDate)
                    : "",
            }));
            setRegisteredDev(mappedRes);
            setIsLoading(false)
        };

        useImperativeHandle(ref,() =>({
            gridLoad: () => handleGridLoad(),
        }));

        useEffect(() => {
            if(openModel){
                handleModalPopUpChange().then(r => true);

            }

        }, [openModel]);

        const handleModalPopUpChange = async () => {
            setShowCloseButton(true);
            modalRef.current?.showModal();

        };

        const onCloseCleanUp =()=>{
            setCloseModel(false);
        }

        const handleDeviceRegister = (selectedType) =>{
            switch (selectedType.key) {
                case 1:
                    setDeviceRegisterType(selectedType.key);
                    handleQRPopUpChange().then(r => null)
                    break;
                case 2:
                    setDeviceRegisterType(selectedType.key);
                    handleSMSPopUpChange().then(r => null);
                    break;
                case 3:
                    setDeviceRegisterType(selectedType.key);
                    handleSMSPopUpChange().then(r => null);
                    break;
            }
        };

        const handleQRPopUpChange = async () => {
            setIsLoading(true);
            setIsDeviceRegisterPopup(true);
            setShowCloseButton(false);
            const response = await getDeviceRegistrationData(company, user.username);
            const transformedData = transformData(response.deviceRegistrationDataViewList, response.authCodeFromMobile.vqrAuthKey, response.authCodeFromMobile.vqrId);
            const mapData = JSON.stringify(transformedData.regData);
            setDevRegData(mapData);
            setIsLoading(false);
        };

        const handleSMSPopUpChange = async () => {
            setIsLoading(true);
            setCurrentContactErrors({});
            setIsDeviceRegisterPopup(true);
            setShowCloseButton(false);
            setIsLoading(false);
        };

        const transformData = (data, verifyAuthCode, vqrId) => {
            if (!data || !data.length) return null;
            const { regCompany, comCompany, comLogo } = data[0];
            const registerData = data.map(({  regTypeName, regValue }) => ({
                regTypeName,
                regValue,
            }));

            return {
                regData: {regCompany:userCompany.comId, registerData, verifyAuthCode, vqrId },
            };
        };

        const handleQRPopUpCloseChange =()=>{
            setIsLoading(true);
            const timer = setTimeout(2000);
            setIsDeviceRegisterPopup(false);
            setShowCloseButton(true);
            setIsLoading(false);
        };

        useEffect(() => {
            (async () => {

                const activeData = await getDropdownData("active");
                setActiveOptions(activeData);

                const regData = await getDropdownData("dev_reg_type");
                setRegisterTypeOptions(regData);

            })();
        }, []);

        const requestProcess = async (e)=> {
            e.preventDefault();
            setSelectedRows([])
            setIsLoading(true);
            const selectedDeviceIds =  selectedRows?.map((data) => data.urgId);
            if (selectedDeviceIds.length === 0) {
                setIsLoading(false);
                toast.error("Please select a device to process!", { autoClose: 5000, containerId: "Main" });
                return;
            } else {
                const res= await processDeviceActive(
                    selectedDeviceIds.join(","),
                    active
                )
                if(res !== null){
                    toast.success("Request active status changed!", { autoClose: 5000, containerId: "Main" });
                    handleGridLoad(e);
                }
                setIsLoading(false);
            }

        }

        const handleSubmit = async (e) => {
            e.preventDefault();
            setIsSubmitLoading(true);
            let regErrors = {};
            setIsLoading(true);
            const mobileRegData = formRef.current.getData();
            regErrors = deviceRegisterFormValidation({
                ...mobileRegData,
            });
            if (Object.keys(regErrors).length > 0) {
                setCurrentContactErrors(regErrors);
            } else {

                if (mobileRegData.regAlertType === '') {
                    toast.error("Please select an alert type!", {
                        autoClose: 5000,
                        containerId: "Modal",
                    });

                }else {
                    try {
                        const response = await getDeviceRegistrationData(company, user.username);
                        const transformedData = transformData(response.deviceRegistrationDataViewList, response.authCodeFromMobile.vqrAuthKey, response.authCodeFromMobile.vqrId);
                        const mapData = JSON.stringify(transformedData.regData);

                        const notifyResponse = await sendRegisterDeviceDataByForm(
                            {
                                registerData: mapData,
                                userId: mobileRegData.regUser,
                                contactDetails: mobileRegData.regAlertType === 3 ? mobileRegData.regMobile : mobileRegData.regEmail,
                                companyId: company,
                                alertType: mobileRegData.regAlertType,
                            }
                        )
                        if (notifyResponse !== null) {
                            toast.success("Device register notification sent!", {autoClose: 5000, containerId: "Modal"});
                            handleGridLoad(e);
                        }

                    } catch (e) {
                        console.error(e.response);
                    }
                }
            }
            setIsSubmitLoading(false);
            setIsLoading(false);
        }

        const handleSubmitReset = (e) => {
            e.preventDefault();
            formRef.current.reset();
        }

        const handleBulkSubmit = async (e) => {
            e.preventDefault();
            setIsSubmitLoading(true);
            setIsLoading(true);
            let regErrors = {};
            const bulkData = bulkRef.current.getData();
            regErrors = deviceBulkRegisterValidation({
                ...bulkData.otherData,
            });
            if (Object.keys(regErrors).length > 0) {
                setCurrentContactErrors(regErrors);
            } else {
                if (bulkData.otherData.dbrAlertType === '') {
                    setIsSubmitLoading(false);
                    setIsLoading(false);
                    toast.error("Please select an notification type!", {
                        autoClose: 5000,
                        containerId: "Modal",
                    });
                    return;
                } else if (bulkData.selectedList.length === 0) {
                    setIsSubmitLoading(false);
                    setIsLoading(false);
                    toast.error("Please select an stakeholder-user to process!", {
                        autoClose: 5000,
                        containerId: "Modal"
                    });
                    return;
                } else {

                    try {

                        const notifyResponse = await sendRegisterBulkData({
                            userStakeholderDetails: bulkData.selectedList,
                            company: company,
                            author: user.username,
                            alertType: bulkData.otherData.dbrAlertType,
                            // stakeholder: bulkData.otherData.dbrStakeholder
                        })
                        if (notifyResponse !== null) {
                            toast.success("Device bulk register notifications sent!", {autoClose: 5000, containerId: "Modal"});
                            handleGridLoad(e);
                        }
                    } catch (e) {
                        console.error(e.response);
                    }
                }
            }
            setIsSubmitLoading(false);
            setIsLoading(false);
        }

        const handleBulkSubmitReset = (e) => {
            e.preventDefault();
            bulkRef.current.reset();
        }

        return (
            <>


                <Modal
                    ref={modalRef}
                    closeButton={showCloseButton}
                    minHeight={isDeviceRegisterPopup === false ?"250px" : "60%"}
                    onCloseCleanUp={onCloseCleanUp}
                    clickOutSide={false}
                >
                    <div >
                        {isLoading ? (
                            <LoadingSpinner />
                        ) : (

                            <div className="ui segment">
                                { isDeviceRegisterPopup === false ? (
                                    <>
                                        <Grid
                                            style={{width:"70vw"}}
                                            ref={gridRef}
                                            multiRowSelection={true}
                                            onSelectionChanged={handleSelectionChanged}
                                            heading="Registered Devices"
                                            isLoading={isSearchLoading}
                                            // handleQRPopUpChange={handleQRPopUpChange}
                                            handleDeviceRegisterPopUpChange={handleDeviceRegister}
                                            showDeviceRegisterButton={devPermissions}
                                            content={registeredDev}
                                            deviceRegisterOpt = {registerTypeOptions}
                                            config={[
                                                {
                                                    headerName: "Id",
                                                    field: "urgId",
                                                    sort: "desc",
                                                    hide: true,
                                                },
                                                {
                                                    headerName: "Code",
                                                    field: "urgCode",
                                                    headerCheckboxSelection: true,
                                                    checkboxSelection: true,
                                                },
                                                {
                                                    headerName: "Device Name",
                                                    field: "urgDeviceName",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Company Name",
                                                    field: "comCompany",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Device Created User",
                                                    field: "createdBy",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Device Created Date",
                                                    field: "createdDate",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Last Modified User",
                                                    field: "lastModifiedBy",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Last Modified Date",
                                                    field: "lastModifiedDate",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Device Owner",
                                                    field: "urgUser",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Last Logged User",
                                                    field: "lastLoggedBy",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Last Logged Date",
                                                    field: "lastLoggedDate",
                                                    cellRenderer: ScrollingTextRenderer,
                                                },
                                                {
                                                    headerName: "Status",
                                                    field: "urgStatus",
                                                    cellRenderer: StatusCellStyle,
                                                },
                                                {
                                                    headerName: "Active",
                                                    field: "urgActive",
                                                    cellRenderer: ActiveCellStyle,
                                                },
                                            ]}

                                        />
                                        {selectedRows.length > 0 && (
                                            <form className="ui form segment">
                                                <h4 className="ui dividing header">Action</h4>
                                                <div className="four fields ">
                                                    <Dropdown
                                                        required={true}
                                                        label="Action"
                                                        placeholder="Action"
                                                        options={activeOptions}
                                                        value={active}
                                                        style={{height: "5px"}}
                                                        onChange={(e, data) => {
                                                            setActive(data.value)
                                                        }}
                                                        clearable={false}
                                                    />
                                                    <div
                                                        style={{
                                                            width: "50%",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "flex-end",
                                                        }}
                                                    >
                                                        <div className="field">
                                                            <Button
                                                                className="ui primary right floated button"
                                                                onClick={(e) => {
                                                                    requestProcess(e);
                                                                }}
                                                                label="Process"
                                                                Icon={Cpu}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        )}
                                    </>

                                ) : (
                                    <div>
                                        <div className="two fields">
                                            <div></div>
                                            {deviceRegisterType === 1 ?(
                                                <div className="ui segment" 
                                                style={{width:"50vw", minWidth:"500px"}}
                                                >
                                                    <QRCode
                                                        value={devRegData.toString()}
                                                        size={512}
                                                        bgColor={"#ffffff"}
                                                        fgColor={"#426bf3"}
                                                        level={"H"}
                                                        showQrCloseButton={true}
                                                        handleQRPopUpCloseChange={handleQRPopUpCloseChange}
                                                        style={{}}
                                                        positionStyle={{
                                                            marginTop: "20px", display: "flex", justifyContent: "center"
                                                        }}
                                                    />
                                                </div>
                                            ): deviceRegisterType === 2 ?(
                                                <div className="ui segment"
                                                     style={{height: "40vh", width:"50vw", minWidth:"500px", minHeight:"400px"}}
                                                >
                                                    <form
                                                        className="drawer-content" onSubmit={handleSubmit}
                                                    >
                                                        <DeviceRegisterForm
                                                            ref={formRef}
                                                            showQrCloseButton={true}
                                                            currentContactErrors={currentContactErrors}
                                                            handleQRPopUpCloseChange={handleQRPopUpCloseChange}
                                                             style={{overflowY: "auto"}}
                                                            positionStyle={{
                                                                marginTop: "20px",
                                                                display: "flex",
                                                                justifyContent: "center"
                                                            }}
                                                        />
                                                        <div
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "flex-end",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    padding: "10px 10px 10px 0",
                                                                }}
                                                            >
                                                                <Button
                                                                    template="reset"
                                                                    onClick={(e) => {
                                                                        handleSubmitReset(e);
                                                                    }}
                                                                />
                                                                <Button
                                                                    type="submit"
                                                                    template="create"
                                                                    isLoading={isSubmitLoading}
                                                                    create={true}
                                                                />
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            ):deviceRegisterType === 3 ?(
                                                <>
                                                    <div className="ui segment">
                                                        <form
                                                            className="drawer-content" onSubmit={handleBulkSubmit}
                                                        >
                                                            <DeviceBulkRegister
                                                                ref={bulkRef}
                                                                showQrCloseButton={true}
                                                                currentContactErrors={currentContactErrors}
                                                                handleQRPopUpCloseChange={handleQRPopUpCloseChange}
                                                                style={{overflowY: "auto"}}
                                                                positionStyle={{
                                                                    marginTop: "20px",
                                                                    display: "flex",
                                                                    justifyContent: "center"
                                                                }}
                                                            />
                                                            <div
                                                                style={{
                                                                    width: "100%",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "flex-end",
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Button
                                                                        template="reset"
                                                                        onClick={(e) => {
                                                                            handleBulkSubmitReset(e);
                                                                        }}
                                                                    />
                                                                    <Button
                                                                        type="submit"
                                                                        template="create"
                                                                        isLoading={isSubmitLoading}
                                                                        create={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </>
                                            ) : null}
                                        </div>

                                    </div>

                                )}
                            </div>
                        )}
                    </div>
                </Modal>
            </>
        );
    }
)
export default RegisterDevices;
